package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SchoolStatisticsResponse(
    val timestamp: String = "",
    val scope: String = "",
    val statistics: SchoolStatisticsMetrics = SchoolStatisticsMetrics()
)

@Serializable
data class SchoolStatisticsMetrics(
    val subjects: SchoolStatisticsCountMetrics = SchoolStatisticsCountMetrics(),
    val classes: SchoolStatisticsCountMetrics = SchoolStatisticsCountMetrics(),
    val staff: SchoolStatisticsStaffMetrics = SchoolStatisticsStaffMetrics(),
    val students: SchoolStatisticsCountMetrics = SchoolStatisticsCountMetrics(),
    val parents: SchoolStatisticsCountMetrics = SchoolStatisticsCountMetrics()
)

@Serializable
data class SchoolStatisticsStaffMetrics(
    val total: Int = 0,
    val active: Int = 0,
    val inactive: Int = 0,
    val teachers: SchoolStatisticsCountMetrics = SchoolStatisticsCountMetrics(),
    @SerialName("school_staff")
    val supportStaff: SchoolStatisticsCountMetrics = SchoolStatisticsCountMetrics()
)

@Serializable
data class SchoolStatisticsCountMetrics(
    val total: Int = 0,
    val active: Int = 0,
    val inactive: Int = 0
)
